import React from 'react'
import Hotelnightview from "../images/Hotelnightview_photo.jpeg";
import kitchen from "../images/kitchen kalimpong.jpg";

import Navbar from '../inc/Navbar';
function Gallery() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <div className='album py-2'>
        <div className='container'>
          <div className="row">


            <div className="col-md-4 mt-3">
              <img src={Hotelnightview} className="card-img-top" alt="Hotelnightview" />

            </div>
             <div className="col-md-4 mt-3">
              <img src={kitchen} className="card-img-top" alt="kitchen" />

            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
  )
}

export default Gallery